import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ACTIONS, URLS } from '../../_config';
import { useStoreApi } from '../../store/api/hooks/storeApiHook';
import { useForm, Controller } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import Icon from '../../components/icons';
import { toast } from 'react-hot-toast';
import { useStoreSelector } from '../../store/selectors/userSelector';
import './style.css';
import Spinner from '../../components/iconSvgs/spinner';
import { StoreTpypeApiResponse } from '../../_config/interfaces/interfaces';

const StoreCreate: React.FC = () => {
    const [isOnSubmitLoading, setOnSubmitLoading] = useState<boolean>(false);
    const [storeTypeList, setStoreTypeList] = useState<Array<StoreTpypeApiResponse>>([]);
    const { register, control, setError, formState: { errors }, handleSubmit, } = useForm<any>();

    const store = useStoreSelector();
    const storeAPI: any = useStoreApi();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const getStores = () => {
        storeAPI.getStore({}, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            if (resp?.data) {
                dispatch({
                    type: ACTIONS.STORE.GET_STORE,
                    payload: resp.data,
                });
                navigate(URLS.STORE.BRANCHES);
            } else {
                navigate(URLS.STORE.CREATE);
            }
        }, (err: any) => {
            // console.log('error =>', err);
            // toast.error(err);
            navigate(URLS.STORE.CREATE);
        })
    }

    const getStoreTypes = () => {
        storeAPI.getStoreTypes({}, (msg: any, resp: any) => {
            // console.log('response =>', resp, msg);
            setStoreTypeList(resp?.data);
        }, (err: any) => {
            // console.log('error =>', err);
            // toast.error(err);
            navigate(URLS.STORE.CREATE);
        })
    }

    const onSubmit = (data: any) => {
        setOnSubmitLoading(true);
        const param = {
            name: data.storeName,
            storetype_id: data.storeType?.value,
            branches: [
                {
                    branch_name: "Branch 1",
                    address: data.storeAddress,
                    contact_info: "+9999999999"
                }
            ]
        }
        // console.log({param, data});
        // setOnSubmitLoading(false);
        // return;

        try {
            setTimeout(() => {
                storeAPI.addStore(param, (msg: any, resp: any) => {
                    // console.log('response =>', resp);
                    if (resp?.code === 201) {
                        dispatch({
                            type: ACTIONS.STORE.GET_STORE,
                            payload: resp.data,
                        });
                        navigate(URLS.STORE.BRANCHES);
                    } else {
                        toast.error(resp?.message);
                    }
                }, (error: any, resp: any) => {
                    const code = resp?.code ?? resp?.detail?.code;
                    const message = resp?.message ?? resp?.detail?.message;
                    if (code === 400) {
                        if (message?.toLowerCase().includes('store name') || message?.toLowerCase().includes('unique')) {
                            setError('storeName', { type: 'manual', message });
                        } else {
                            toast.error(message || 'Something went wrong');
                            if (!resp?.detail?.data) {
                                getStores();
                            }
                        }
                    } else {
                        toast.error(message || 'Something went wrong');
                    }
                });

                setOnSubmitLoading(false);
            }, 5000)
        } catch (e) {
            // console.log('error =>', e);
            setOnSubmitLoading(false);
        }
    };

    useEffect(() => {
        getStoreTypes()
    },[])

    return (
        <div className="flex min-h-screen">
            {isOnSubmitLoading && (
                <div className="absolute inset-0 bg-gray-700 bg-opacity-50 flex justify-center items-center z-50">
                    <Spinner className="self-center z-50" />
                </div>
            )}
            
            <div className="flex flex-col justify-center w-full md:items-center md:w-2/5 lg:w-[35%] px-5 sm:px-8 py-8 sm:py-10 lg:px-10 bg-white">
                <div className="w-full sm:max-w-2xl">
                    <img className="h-15 w-auto mb-8 sm:mb-12" src="/assets/images/Frame_2.png" alt="hubwallet logo" />
                    <h2 className="mt-10 text-left text-2xl font-bold tracking-tight text-gray-900">Add Store</h2>
                    <p className="mt-1 text-left text-base tracking-tight text-gray-500">Add store name and store type</p>
                </div>

                <div className="mt-5 sm:mx-auto sm:w-full sm:max-w-2xl">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-5">
                            <div className="mt-2 relative">
                                <input
                                    type="text"
                                    {...register("storeName", { required: true })}
                                    placeholder="Store Name"
                                    autoComplete="username"
                                    className={`block-lg w-full rounded-sm bg-white px-4 sm:px-3 py-3 sm:py-1.5 pr-10 text-base sm:text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.storeName ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600`}
                                />
                                <Icon name="store" size={20} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            </div>
                            {errors.storeName && (
                                <p className="mt-1 text-xs text-red-500">
                                    {(errors.storeName as any).message || 'Store name is required'}
                                </p>
                            )}
                        </div>

                        <div className="mb-5">
                            <div className="mt-2">
                                <Controller
                                    name="storeType"
                                    control={control}
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            options={storeTypeList?.map((item: StoreTpypeApiResponse) => ({
                                                value: item.storetype_id,
                                                label: item.store_type,
                                            })) || []}
                                            placeholder="Select Store Type"
                                            isSearchable={false}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    borderRadius: '2px',
                                                    borderColor: errors.storeType ? '#ef4444' : state.isFocused ? '#3b82f6' : '#d1d5db',
                                                    borderWidth: '1px',
                                                    boxShadow: 'none',
                                                    '&:hover': { borderColor: state.isFocused ? '#3b82f6' : '#d1d5db' },
                                                    minHeight: '36px',
                                                    fontSize: '14px',
                                                    backgroundColor: 'white',
                                                    width: '100%',
                                                }),
                                                placeholder: (base) => ({ ...base, color: '#9ca3af', fontSize: '14px' }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    color: state.isSelected ? 'white' : '#6b7280',
                                                    backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#eff6ff' : 'white',
                                                    fontSize: '14px',
                                                }),
                                                singleValue: (base) => ({ ...base, color: '#111827', fontSize: '14px' }),
                                            }}
                                        />
                                    )}
                                />
                            </div>
                        </div>


                        <div className="mb-5">
                            <div className="mt-2 relative">
                                <input
                                    type="text"
                                    {...register("storeAddress", { required: true, minLength: { value: 5, message: "Store address must be at least 5 characters long." } })}
                                    placeholder="Store Address"
                                    className={`block-lg w-full rounded-sm bg-white px-4 sm:px-3 py-3 sm:py-1.5 pr-10 text-base sm:text-sm text-gray-900 outline outline-1 -outline-offset-1 ${errors.storeAddress ? 'outline-red-500 outline-2' : 'outline-gray-300'} placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600`}
                                />
                                <Icon name="location" size={20} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" />
                            </div>
                            {errors.storeAddress && (
                                <span className="text-red-500 text-xs">Store address must be at least 5 characters long.</span>
                            )}
                        </div>


                        <div className="mb-5">
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-sm bg-blue-500 py-3.5 sm:py-4 text-base sm:text-sm font-semibold text-white shadow-sm hover:bg-blue-600 transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Submit
                            </button>
                        </div>
                    </form>


                </div>
            </div>

            {/* Right Side: Background Image Section */}
            <div className="hidden md:block md:w-3/5 lg:w-[65%] bg-cover" style={{ backgroundImage: 'url(/assets/images/2148204009-1.jpg)' }}>
            </div>
        </div>
    );
};

export default StoreCreate;